<template>
    <v-dialog v-model="selectedValue" max-width="50%" persistent>
        <v-card>
            <v-card-title class="headline">
                <span v-if="titleIcon" class="titleIcon">
                    <slot name="titleIcon"></slot>
                </span>
                {{ title || $t('ARE_YOU_SURE')}}
                <v-spacer/>
                <slot name="titleActions"></slot>
            </v-card-title>
            <v-card-text>
                <slot></slot>
            </v-card-text>
            <v-card-actions class="pl-2 pr-3 pb-3">
                <slot name="bottomLeft"></slot>
                <v-spacer></v-spacer>
                <slot name="bottom"></slot>
                <v-btn
                    v-if="cancel!==false"
                    color="confirm"
                    text
                    @click.native="show = false"
                    @click="$emit('cancel'); $emit('input', false);"
                    :disabled="disabled || loading || cancelDisabled"
                >{{ cancel || $t('CANCEL') }}</v-btn>
                <v-btn
                    v-if="confirm!==false"
                    :color="confirmColor || 'confirm'"
                    @click.native="show = false"
                    @click="$emit('confirm')"
                    :disabled="disabled || loading || confirmDisabled"
                >{{ confirm || $t('CONFIRM') }}</v-btn>
                <slot name="bottomRight"></slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
@Component({})
export default class ConfirmationDialog extends Vue {
    // Until rewriting correctly, using Prop() is equivalient to any type.
    // For some reason we use cancel and confirm with many different types.
    @Prop() cancel;
    @Prop() confirm;
    @Prop(String) title: string;
    @Prop(Boolean) disabled: boolean;
    @Prop(Boolean) value: string;
    @Prop(Boolean) loading: boolean;
    @Prop(Boolean) cancelDisabled: boolean;
    @Prop(Boolean) confirmDisabled: boolean;
    @Prop(String) confirmColor: string;

    isOpen: boolean = true;
    get selectedValue(): boolean {
        if (this.value) {
            return true;
        } else {
            return false;
        }
    }
    get titleIcon() {
        return this.$slots["titleIcon"];
    }
}
</script>

<style>
.titleIcon {
    display: inline-block;
    padding-right: 10px;
}
</style>
